import find from 'lodash/find';
import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...state,
        initParams: action.initParams,
      };
    case actions.INVALIDATE.END:
      return {
        ...state,
        items: action.items,
      };
    case actions.INIT.COMPANY.BEGIN:
      return {
        ...state,
        companyOptions: [{ label: 'loading...' }],
      };
    case actions.INIT.COMPANY.END:
      return {
        ...state,
        companyOptions: action.companyOptions,
        selectedCompany: action.selectedCompany,
      };
    case actions.SET_COMPANY:
      return {
        ...state,
        selectedCompany: find(state.companyOptions, c => c.id === action.companyId),
      };
    case actions.SET_PROJECT_LIST:
      return {
        ...state,
        projectList: action.values.items,
        canCreate: action.values.canCreateNewItem
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/viewer/reducer.js